"use client";

import React from "react";
import { Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GoogleReviews() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const reviews = [{
    name: "Johannes Knöbel",
    rating: 5,
    text: "Bei uns wurde absolut erstklassige Arbeit geleistet. Unsere im Garten stehende Eiche wurde von Totholz befreit, zudem wurde ein Schaukelseil in großer Höhe …"
  }, {
    name: "Eike Sievertsen",
    rating: 5,
    text: "Ich bin begeistert. Sowohl die Absprache als auch das Einhalten des Termins hat schnell und pünktlich geklappt. Dann kamen zwei fröhlich motivierte …"
  }, {
    name: "Malte Brenneisen",
    rating: 5,
    text: "Wir sind über eine persönliche Empfehlung bei Herrn Straesser gelandet – und möchten diese nun weitergeben. Bei unserer Trauerweide war höchste Eile und …"
  }, {
    name: "Ingeborg Westphal",
    rating: 5,
    text: "Sehr gute Arbeit und netter Kontakt\nEmpfehlenswert!!!"
  }, {
    name: "morbyte3",
    rating: 5,
    text: "Professionelle Baumpflege, faire Preise und auf jeden Fall nettes und kompetentes Team!"
  }, {
    name: "Johann Peters",
    rating: 5,
    text: "Ich habe schon mehrfach mit Herrn Sträßer zusammengearbeitet und kann die Arbeit mit ihm als sehr angenehm und professionell bezeichnen! Immer wieder gerne!"
  }, {
    name: "M D",
    rating: 5,
    text: "Haben zwei Bäume geprüft und geschnitten. Pünktlich, freundlich und klar erklärt, was sie machen. Ein paar Zweige hätte ich kürzer gewollt, aber ist echt nur Kleinkram. Sehr gute Arbeit und kompetent"
  }, {
    name: "nikhiil konrad",
    rating: 5,
    text: "Wirklich guter Service. Sie kamen kurzfristig vorbei und haben ruhig und kompetent gearbeitet. Es gab am Anfang eine kurze Verwirrung wegen der Uhrzeit, aber das war schnell geklärt. Am Ende alles top."
  }, {
    name: "Fenja K",
    rating: 5,
    text: "Die Beiden haben bei uns im Hof zwei Bäume zurückgeschnitten die seit Jahren völlig aus der Form waren .Ich hab vorher Angebote eingeholt, bei Strässer war die …"
  }, {
    name: "Tim B",
    rating: 5,
    text: "Gute Kommunikation und schnelle Abwicklung. Alles super"
  }, {
    name: "Liisa Fatuma",
    rating: 5,
    text: "Sehr guter Service"
  }, {
    name: "Beat S",
    rating: 5,
    text: "Sehr schnelle Terminvergabe und wirklich kompetente Ausführung. Baumpflege Sträßer hat sauber gearbeitet, alles wie abgesprochen. Gerne wieder."
  }];
  return <section id="googlereviews" className="relative py-24 overflow-hidden bg-background">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/forest_canopy_light.png)] bg-cover bg-center opacity-40" />
      </div>

      <div ref={ref} className={`relative z-10 container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-6 tracking-tight">
            Das sagen unsere Kunden
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Echte Erfahrungen von zufriedenen Kunden aus Hamburg, Ahrensburg und Umgebung. Überzeugen Sie sich selbst von unserer Qualität.
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {reviews.map((review, i) => <div key={i} data-index={i} className="bg-card p-8 rounded-lg shadow-lg border border-border/50 flex flex-col h-full transition-transform duration-300 hover:scale-[1.02]">
                <div className="flex gap-1 mb-4">
                  {[...Array(review.rating)].map((_, index) => <Star key={index} className="w-5 h-5 fill-primary text-primary" />)}
                </div>
                <p className="text-foreground/90 italic mb-6 flex-grow font-default leading-relaxed">
                  "{review.text}"
                </p>
                <div className="pt-4 border-t border-border/50">
                  <p className="font-serif font-semibold text-foreground">
                    {review.name}
                  </p>
                  <p className="text-xs text-muted-foreground font-mono uppercase tracking-wider mt-1">
                    Google Bewertung
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-16 text-center">
          <Link to="https://share.google/mwoudYgECCsQ8AHqEhinterlg" newTab>
            <Button size="lg" className="relative overflow-hidden group bg-destructive text-destructive-foreground hover:bg-destructive/90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300">
              <span className="relative z-10 flex items-center gap-2">
                Bewertung hinterlassen
                <Star className="w-5 h-5 fill-current" />
              </span>
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:translate-x-full transition-transform duration-1000 ease-in-out" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}